export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
export const DATETIME_SHORT_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATETIME_ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const DATE_FORMAT_FNS = 'dd.MM.yyyy';
export const DATETIME_FORMAT_FNS = 'dd.MM.yyyy HH:mm:ss';
